export default function setSharedUUID({ storage, uuid, state }) {
  const sharedUUID = storage.get('sharedUUID')
  const id = uuid.id()
  if (!sharedUUID) {
    state.set('shared.uuid', id)
  }
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/setSharedUUID.js